import { formatMoneyValue } from "@utils/Currency";
import styles from "./style.module.scss";
import { DocumentSummaryProps } from "@/store/slices/eDocumentSlides";
import { OTHER_CHARGES_PRINT_LABEL } from "@utils/ClientShipping";

type FooterTotalsProps = {
  totalPages: number;
  currentPage: number;
  summary?: DocumentSummaryProps;
  summaryText?: string;
  currencyCode: number
};

const FooterTotals = (props: FooterTotalsProps) => {
  const { currentPage, totalPages, summary, summaryText, currencyCode } = props;

  if (summaryText) {
    return (
      <div className="invoice-totals">
        <div className="table-row bold">
          <label>&nbsp;</label>
        </div>
        {/* <div style="text-align: center;ont-weight: bold; padding: 0px 10px"> */}
        <div className={styles.summaryText}>
          {summaryText}
        </div>
      </div>
    )
  }

  return (
    <>
      {currentPage === totalPages && (
        <div className={`${styles?.invoiceTotals ?? ""} invoice-totals`}>
          <div className="table-row bold">
            <label>Subtotal:</label>
            <div>{formatMoneyValue(summary.subtotal, currencyCode)}</div>
          </div>

          <div className="table-row">
            <label>{summary.descuento ? "Descuento:" : ""} &nbsp;</label>
            <div>{summary.descuento ? formatMoneyValue(summary.descuento, currencyCode) : " "}</div>
          </div>
          <div className="table-row">
            <label> &nbsp;</label>
            <div>&nbsp;</div>
          </div>
          {/* <div className="table-row bold">
            <label>I. Servicio:</label>
            <div>{formatMoneyValue(summary.impuestos, currencyCode)}</div>
          </div> */}
          <div className="table-row">
            <label>I.V.A.</label>
            <div>{formatMoneyValue(summary.impuestos, currencyCode)}</div>
          </div>

          {Number(summary.otrosCargos || 0) > 0 && (
            <div className="table-row">
              <label>{summary.otrosCargosLabel || OTHER_CHARGES_PRINT_LABEL}:</label>
              <div>{formatMoneyValue(summary.otrosCargos, currencyCode)}</div>
            </div>
          )}

          {Number(summary.ivaDevuelto || 0) > 0 && (
            <div className="table-row">
              <label>I.V.A. Devuelto:</label>
              <div>{formatMoneyValue(summary.ivaDevuelto, currencyCode)}</div>
            </div>
          )}

          <div className="table-row bold last">
            <label>Total:</label>
            <div>{formatMoneyValue(summary.total, currencyCode)}</div>
          </div>
        </div>
      )}

      {currentPage !== totalPages && (
        <div className={`${styles?.invoiceTotals ?? ""} invoice-totals--next-page`}>
          <div>Total en Última página</div>
        </div>
      )}
    </>
  );
};

export default FooterTotals;